<template>
  <div
    :class="htmlStatus == true ? 'container' : 'container1'"
    :style="{ backgroundImage: 'url(' + bg + ')' }"
  >
    <!-- 根据值进行判断是否显示留存信息 -->
    <div v-if="htmlStatus">
      <!-- <div class="bannerPic">
        <img src="../../assets/img/bannenr.png" style="width: 100%" alt="" />
      </div> -->
      <div class="backg" v-if="htmlStatus">
        <!-- <div class="cardInfo">
          <div class="cardPic">
            <img :src="cardInfo.photoUrl" style="width: 100%; height: 100%" />
          </div>
          <div class="cardName">{{ cardInfo.cltBusName }}</div>
        </div> -->
        <van-cell-group>
          <van-field
            v-model="form.name"
            placeholder="请输入真实姓名"
            @input="
              (value) => {
                form.name = value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\· _ ]/g, '');
              }
            "
            maxlength="10"
          />
          <van-field
            v-model="form.cardCertnbr"
            maxlength="18"
            @input="
              (value) => {
                form.cardCertnbr = value.replace(/[\W]/g, '');
              }
            "
            placeholder="请输入身份证号"
          />
          <van-field
            v-model="form.cardMobile"
            maxlength="11"
            type="tel"
            @input="
              (value) => {
                form.cardMobile = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入手机号"
          />
          <van-field
            class="lister code2"
            v-model="form.verifyCode"
            maxlength="6"
            placeholder="请输入验证码"
          >
            <template #button>
              <div class="code">
                <div class="codeGroup">
                  <div style="margin-right: 3px" class="line"></div>
                  <div class="subCondeGrpup">
                    <span @click="start" class="codeTxt" v-show="timeStatus == '0001'"
                      >获取验证码</span
                    >
                    <div v-show="timeStatus == '0000'" class="sub">
                      <van-count-down
                        style="color: #368ff9"
                        ref="countDown"
                        millisecond
                        :time="time"
                        :auto-start="false"
                        format="ss"
                        @finish="finish"
                      />&nbsp;&nbsp;&nbsp;
                      <span style="color: #368ff9">秒后重试</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="foot" v-if="htmlStatus">
        <van-button block @click="submit" class="btn">
          <span style="color: #fff">立即申请</span>
        </van-button>
        <div class="infos">
          <van-checkbox v-model="checked" checked-color="#969798" shape="square"
            ><span style="color: #bfc1c9; font-size: 13px"
              >已阅读并同意</span
            ></van-checkbox
          >
          <span
            style="color: #bfc1c9; font-size: 13px; margin-top: 0px"
            @click="policyUrl"
            >《授权政策》</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Field } from "vant";
import { CellGroup, CountDown, Toast, Checkbox } from "vant";
import { Button } from "vant";
import { initiateBusinessOrder, baseUrl } from "../../assets/js/api.js";
import { idCode, isPoneAvailable, checkIdcard } from "../../assets/js/common";
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(CountDown);
Vue.use(Toast);
Vue.use(Checkbox);
export default {
  data() {
    return {
      bg: require("../../assets/img/backg2.png"),
      isDisabled: "0000",
      htmlStatus: false,
      time: 60000,
      timeStatus: "0001",
      checked: false,
      // 卡信息
      cardInfo: {},
      form: {
        // 页面展示得
        name: "", //名字
        cardMobile: "", //手机号
        cardCertnbr: "", //身份证号
        verifyCode: "", //验证码
        // 地址栏自带得
        officeCode: "",
        shopUid: "",
      },
      appTag: 1, //类型 appTag  0 佳付通  1 富裕钱包
      token: "",
    };
  },
  created() {
    // 获取是否展示留存信息页面或直接跳转

    document.title = "立即申请";
    console.log(sessionStorage.getItem("data"));
    if (sessionStorage.getItem("data")) {
      this.form = JSON.parse(sessionStorage.getItem("data"));
    }
    this.form.officeCode = this.$route.query.officeCode;
    this.form.shopUid = this.$route.query.shopUid;
    let appTag = this.$route.query.appTag; //0 佳付通  1 富裕钱包 2 我是队长
    if (appTag) {
      this.appTag = appTag;
    }
    let token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
    this.jumpUrlStatus();
    //this.getCardInfo();
  },
  methods: {
    jumpUrlStatus() {
      baseUrl("/common/v1/queryPinfoFlag", this.form)
        .then((res) => {
          console.log("是否展示页面");
          console.log(res);
          // 如果是0的话展示
          if (res.data.code == "0000") {
            if (res.data.image) {
              this.bg = res.data.image;
            }
            if (res.data.pinfoFlag === "0") {
              this.htmlStatus = true;
            } else {
              this.htmlStatus = false;
              baseUrl(
                "/business/v1/initiateBusinessOrderByShop",
                Object.assign(this.form, { token: this.token })
              )
                .then((res) => {
                  console.log(res);
                  if (res.data.code == "0000") {
                    let handurl = res.data.applyUrl;
                    window.location.href = handurl;
                    this.form.name = "";
                    this.form.cardMobile = "";
                    this.form.cardCertnbr = "";
                    this.form.verifyCode = "";
                    this.timeStatus = "0001";
                    this.time = "60000";
                  } else {
                    Toast(res.data.msg);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            return;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取卡名字和卡图片
    getCardInfo() {
      baseUrl("/common/v1/queryCltBusPhoto", this.form)
        .then((res) => {
          console.log("卡信息↓");
          console.log(res);
          this.cardInfo = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    policyUrl() {
      sessionStorage.setItem("data", JSON.stringify(this.form));
      this.$router.push({
        name: "authorization4",
      });
    },
    // 页面提交
    submit() {
      if (
        this.form.name == "" ||
        this.form.cardMobile == "" ||
        this.form.cardCertnbr == "" ||
        this.form.verifyCode == ""
      ) {
        Toast("数据全为必填项");
        return false;
      }

      if (this.form.name.indexOf(" ") != -1) {
        Toast("姓名不能包含空格");
        return false;
      }

      if (new RegExp("[0-9]").test(this.form.name)) {
        Toast("姓名不能包含数字");
        return false;
      }

      if (isPoneAvailable(this.form.cardMobile) == false) {
        Toast("手机号码不合法，请重新输入");
        return false;
      }

      if (this.form.cardCertnbr.length != 18) {
        Toast("身份证号为18位");
        return false;
      }

      // if (idCode(this.form.cardCertnbr) == false) {
      //   Toast("身份证号输入有误");
      //   return false;
      // }

      // if (checkIdcard(this.form.cardCertnbr) == false) {
      //   Toast("身份证号码输入有误");
      //   return false;
      // }

      if (this.checked == false) {
        Toast("请勾选授权协议");
        return false;
      }

      baseUrl(
        "/business/v1/initiateBusinessOrderByShop",
        Object.assign(this.form, { token: this.token })
      )
        .then((res) => {
          console.log(res);
          if (res.data.code == "0000") {
            let handurl = res.data.applyUrl;
            window.location.href = handurl;
            this.form.name = "";
            this.form.cardMobile = "";
            this.form.cardCertnbr = "";
            this.form.verifyCode = "";
            this.timeStatus = "0001";
            this.time = "60000";
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    start() {
      if (this.form.cardMobile == "") {
        Toast("手机号不能为空");
        return false;
      }

      if (this.form.cardMobile.length != "11") {
        Toast("手机号输入有误");
        return false;
      }

      if (isPoneAvailable(this.form.cardMobile) == false) {
        Toast("手机号输入有误");
        return false;
      }
      if (this.isDisabled == "0001") {
        console.log("不让点击");
        return false;
      }
      this.isDisabled = "0001";

      let obj = {
        phone: this.form.cardMobile,
        commendCode: this.form.officeCode,
      };
      baseUrl("/message/v1/creditSend", obj)
        .then((res) => {
          this.isDisabled = "0000";
          console.log(res);
          if (res.data.code == "0000") {
            this.timeStatus = "0000";
            this.$refs.countDown.start();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch((err) => {
          Toast("失败，请稍后再试！");
          console.log(err);
          this.isDisabled = "0000";
        });
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.timeStatus = "0001";
      // this.time = "60000";
      this.reset();
    },
  },
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  max-width: 500px;
  height: 100vh;
  background-color: #f5f9fd;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100% 240px;
  padding-top: 240px;
}
.container1 {
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  max-width: 500px;
  height: 100vh;
  background: none !important;
  background-color: #f5f9fd !important;
}
.codeGroup {
  display: flex;
}
.sub {
  display: flex;
  align-items: center;
  width: 100px;
  margin-left: 5px;
  border: 0px;
}
.van-button--default {
  border: 0px;
}
.codeTxt {
  color: #368ff9;
  width: 100px;
  margin-left: 5px;
}
.subCondeGrpup {
  width: 80px;
}
.btn {
  width: 90%;
  margin: 0 auto;
  background: #214afd;
  border-radius: 20px;
  margin-top: 50px;
}
.infos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.line {
  border: 1px solid #368ff9;
  height: 20px;
  margin-top: 8px;
}
.cardInfo {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
/deep/ [class*="van-hairline"]::after {
  border-left: 0;
  border-right: 0;
  border-top: 0;
}
.cardPic {
  height: 90px;
  width: 90px;
}
.cardName {
  font-size: 20px;
  font-weight: 600;
  margin-top: 10px;
  margin-left: 10px;
}
.backg {
  background-size: 100% 100%;
  margin: 0 auto;
  width: 90%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  top: 25%;
}
.van-cell {
  line-height: 38px;
}
.foot {
  position: relative;
  top: 35%;
  white-space: nowrap;
}
.input {
  caret-color: #000;
}
@media (max-width: 360px) {
  .btn {
    margin-top: 12px;
  }
}
</style>
